// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"171":"7f8db168","678":"7f8db168","971":"96420c18"}[chunkId] + ".css";
};